import * as React from 'react'
function SvgId(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28 4H6v32h22c3.4 0 6-2.6 6-6V10c0-3.4-2.6-6-6-6zm-8 8c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm4 16h-8a2 2 0 110-4h8a2 2 0 110 4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgId
